import React from 'react';
import PropTypes from 'prop-types';
import { withRouter, matchPath } from 'react-router';

import { MobileMenuList } from 'components';
import { mapStateToProps } from 'utils/redux-decorators';
import { ROUTES } from 'config/constants';
import { configMobileMenu } from './helpers';

@withRouter
@mapStateToProps(({ authState }) => ({
  authState,
}))
export class MobileMenu extends React.PureComponent {
  static propTypes = {
    options: PropTypes.object,
    hideModal: PropTypes.func,
  };

  static defaultProps = {
    options: {},
  };

  state = {
    isOpen: [],
  };

  componentDidMount() {
    const {
      location,
      authState: { authInfo: { id } = {} },
      options: { userRole } = {},
    } = this.props;

    const menuList = configMobileMenu(userRole, id);
    const indexActiveGroup = menuList.findIndex(({ childrens }) => {
      if (childrens) {
        return childrens.find((item) => item.route === location.pathname);
      }
      return false;
    });

    this.handleIsOpen(indexActiveGroup);
  }

  handleIsOpen = (index) => {
    const { isOpen } = this.state;
    const helpArr = [...isOpen];

    if (helpArr.includes(index)) {
      for (let i = 0; i < helpArr.length; i++) {
        if (index === helpArr[i]) {
          helpArr.splice(i, 1);
        }
      }
    } else {
      helpArr.push(index);
    }

    this.setState({ isOpen: helpArr });
  };

  handleCheckActive = (path) => {
    const { location } = this.props;

    return Boolean(
      matchPath(location.pathname, {
        path: path,
        exact: true,
      }),
    );
  };

  handleIsGroupActive = (title) => {
    switch (title) {
      case 'Sponsors':
        return [
          ROUTES.SPONSORS,
          ROUTES.MY_SPONSORS,
          ROUTES.SPONSOR_PROFILE_REQUESTS,
        ].some((path) => this.handleCheckActive(path));
      case 'Personnel':
        return [ROUTES.ALL_PERSONNEL, ROUTES.LINKING_REQUESTS].some((path) =>
          this.handleCheckActive(path),
        );
      case 'All Research Sites':
      case 'Research Sites':
        return [
          ROUTES.RESEARCH_SITES,
          ROUTES.MY_RESEARCH_SITES,
          ROUTES.RESEARCH_SITE_PROFILE_REQUESTS,
        ].some((path) => this.handleCheckActive(path));

      default:
        return false;
    }
  };

  render() {
    const {
      authState: { authInfo: { id } = {} },
      options: { additionalClassName, style, userRole } = {},
      hideModal,
    } = this.props;
    const { isOpen } = this.state;
    const menuList = configMobileMenu(userRole, id);

    return (
      <div
        className={`white-box mobile-menu-modal ${additionalClassName}`}
        style={style}
      >
        <MobileMenuList
          data={menuList}
          isOpen={isOpen}
          handleHideModal={hideModal}
          handleCheckActive={this.handleCheckActive}
          handleIsOpen={this.handleIsOpen}
          handleIsGroupActive={this.handleIsGroupActive}
        />
      </div>
    );
  }
}
